<div class="aberration-info aberration-content-height">
  <div class="Flexbox navigation-pane">
    <span class="Flexbox Spacebox__tiny full-width navigation-pane_category"
          [ngClass]="{'selected-category': ('category_' + therapyMatchCategory) === currantSection}"
          (click)="scrollTo('category_' + therapyMatchCategory)"
          *ngFor="let therapyMatchCategory of therapyMatchCategories" translate>{{'therapyMatch.' + therapyMatchCategory}}</span>
    <span class="Flexbox Spacebox__tiny full-width navigation-pane_category"
          [ngClass]="{'selected-category': ('category_' + annotationCategory) === currantSection}"
          (click)="scrollTo('category_' + annotationCategory)"
          *ngFor="let annotationCategory of annotationsCategories">{{annotationCategory}}</span>
    <span class="Flexbox Spacebox__tiny full-width navigation-pane_category"
          [ngClass]="{'selected-category': ('category_' + clinicalTrialCategory) === currantSection}"
          (click)="scrollTo('category_' + clinicalTrialCategory)"
          *ngFor="let clinicalTrialCategory of clinicalTrialCategories" translate>{{'clinicalTrials.' + clinicalTrialCategory}}</span>
  </div>
  <aberration-info-tab-content
    [aberrationExtras]="aberrationExtrasFiltered"
    [aberration]="aberrationContent"
    [therapyMatchCategories]="therapyMatchCategories"
    [clinicalTrialCategories]="clinicalTrialCategories"
    [annotationsCategories]="annotationsCategories"
    [therapyMatches]="therapyMatches"
    [clinicalTrials]="clinicalTrials"
    [testTableData]="testTableData"
    [configuration]="configuration"
    [currentModality]="currentModality"
    (scrollLocationChanged)="onScrollLocationChanged($event)"
    (contentUpdated)="aberrationInfoTabContentUpdated($event)">
  </aberration-info-tab-content>
</div>
